import { PageHeader } from "@/components/Primitives";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import StaffManager from "@/components/admin/StaffManager";
import AdminSnapshot from "@/components/admin/AdminSnapshot";
import AssignmentTool from "@/components/admin/AssignmentTool";
import UnassignedTerritory from "@/components/admin/UnassignedTerritory";
import PermissionMatrix from "@/components/admin/PermissionMatrix";
import TrashManager from "@/components/admin/TrashManager";
import AuditLog from "@/components/admin/AuditLog";
import DocumentLibrary from "@/pages/DocumentLibrary";
import CrudResource from "@/components/CrudResource";
import { Users, ArrowRightLeft, Archive, FolderOpen, Package, ScrollText, MapPinOff, ShieldCheck } from "lucide-react";

export default function AdminControlCenter() {
  return (
    <div data-testid="page-admin-control-center">
      <PageHeader title="Admin Control Center" subtitle="Manage staff, assignments, records, documents, products and security — all in one place." />
      <AdminSnapshot />
      <Tabs defaultValue="staff">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="staff" data-testid="acc-tab-staff"><Users className="h-4 w-4 mr-1.5" />Staff</TabsTrigger>
          <TabsTrigger value="assignments" data-testid="acc-tab-assignments"><ArrowRightLeft className="h-4 w-4 mr-1.5" />Assignments</TabsTrigger>
          <TabsTrigger value="unassigned" data-testid="acc-tab-unassigned"><MapPinOff className="h-4 w-4 mr-1.5" />Unassigned Territory</TabsTrigger>
          <TabsTrigger value="trash" data-testid="acc-tab-trash"><Archive className="h-4 w-4 mr-1.5" />Records / Trash</TabsTrigger>
          <TabsTrigger value="documents" data-testid="acc-tab-documents"><FolderOpen className="h-4 w-4 mr-1.5" />Documents</TabsTrigger>
          <TabsTrigger value="products" data-testid="acc-tab-products"><Package className="h-4 w-4 mr-1.5" />Products & Services</TabsTrigger>
          <TabsTrigger value="security" data-testid="acc-tab-security"><ScrollText className="h-4 w-4 mr-1.5" />Security / Audit</TabsTrigger>
          <TabsTrigger value="permissions" data-testid="acc-tab-permissions"><ShieldCheck className="h-4 w-4 mr-1.5" />Permissions</TabsTrigger>
        </TabsList>
        <TabsContent value="staff" className="mt-5"><StaffManager /></TabsContent>
        <TabsContent value="assignments" className="mt-5"><AssignmentTool /></TabsContent>
        <TabsContent value="unassigned" className="mt-5"><UnassignedTerritory /></TabsContent>
        <TabsContent value="trash" className="mt-5"><TrashManager /></TabsContent>
        <TabsContent value="documents" className="mt-5"><DocumentLibrary /></TabsContent>
        <TabsContent value="products" className="mt-5"><CrudResource resourceKey="products" /></TabsContent>
        <TabsContent value="security" className="mt-5"><AuditLog /></TabsContent>
        <TabsContent value="permissions" className="mt-5"><PermissionMatrix /></TabsContent>
      </Tabs>
    </div>
  );
}
